










































































































































































































import {Component, Prop} from "vue-property-decorator";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {LadingStatus} from "@/enums/status";
import {FormModel} from "ant-design-vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {LadingErrorStatus} from "@/enums/status/ladingerror";
import {LadingErrorStore} from "@/modules/ladingerror/store";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import LadingSelector from "@/shared/components/LadingSelector/index.vue";

const lading = {
  rowGuid: "",
  deliveryPostOffice: {
    name: ""
  },
  locationFrom: {
    phoneNumber: "",
    name: "",
    address: "",
    wardId: undefined,
    districtId: undefined,
    provinceId: undefined,
    countryId: 1
  },
  customer: {
    customerCode: ""
  },
  locationTo: {
    phoneNumber: "",
    name: "",
    address: "",
    wardId: undefined,
    districtId: undefined,
    provinceId: undefined,
    street: {
      name: ""
    },
    ward: {
      name: ""
    },
    district: {
      name: ""
    },
    province: {
      name: ""
    },
    countryId: 1
  },
  ladingCode: undefined,
  status: undefined
}
@Component({
  name: "LadingErrorForm",
  components: {LadingSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
  labelCol = {span: 7};
  wrapperCol = {span: 17};
  LadingStatus = LadingStatus;
  limitStatus = [
    LadingStatus.DuyetHoan,
    LadingStatus.PhatLai,
    LadingStatus.DuyetChuyenTiep,
    LadingStatus.PhatTiep
  ];
  LadingErrorStatus = LadingErrorStatus;
  @Prop()
  readonly id!: number;

  get locationToPhoneNumber() {
    return this.getProp(this.billLadingForm, "locationTo.phoneNumber") || ''
  }

  get locationFromPhoneNumber() {
    return this.getProp(this.billLadingForm, "locationFrom.phoneNumber") || ''
  }

  private address = "";
  private deliveryTarget = ""
  private form = {
    id: undefined,
    note: "",
    billLadingRowGuid: "",
    solution: "",
    status: undefined,
    billLadingStatus: undefined,
    createdBy: "",
      customerResponse: "",
      customerResponseAt: ""
  }
  private billLadingForm = {...lading}
  private rules = {
    solution: [{required: true, message: "Nhập giải pháp"}],
    status: [{required: true, message: "Chọn trạng thái chuyển"}]
  }

  private onSubmit() {
    (this.$refs.formLadingError as FormModel).validate(async valid => {
      if (!valid) return;
      try {
        await LadingErrorStore.updateLadingError(this.form)
        this.$notification.success({
          message: "Thành công",
          description: `Cập nhật thành công`
        });
        this.$router.push({name: "listLadingError"});
      } catch (e) {
        this.$notification.error({
          message: "Thất bại",
          description: `${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} khiếu nại thất bại`}`
        })
      }
    })
  }

  async created() {
    if (this.id) {
      try {
        const data = await LadingErrorStore.singleLadingError(this.id);
        this.form = assignValueToForm(this.form, data);
        this.billLadingForm = assignValueToForm(this.billLadingForm, data.billLading);
          if (this.limitStatus.includes(data.billLading.status)) {
              this.form.billLadingStatus = data.billLading.status;
          }
        if (data.billLading.deliveryEmployee)
          this.deliveryTarget = data.billLading.deliveryEmployee?.fullname || "" + " - " + data.billLading.deliveryEmployee?.phoneNumber || ""
        if (data.billLading.deliveryPartner)
          this.deliveryTarget = data.billLading?.deliveryPartner?.name || ""
        if (this.billLadingForm.locationTo)
          this.address = `${this.billLadingForm?.locationTo?.address || ""}, ${this.billLadingForm?.locationTo?.street?.name || ""},${this.billLadingForm?.locationTo?.ward?.name || ""}, ${this.billLadingForm.locationTo?.district?.name || ""}, ${this.billLadingForm?.locationTo?.province?.name}`.replace(", ,", ", ")
        this.form.createdBy = data.createdBy.employee ? data.createdBy.employee.employeeCode + " - " + data.createdBy.employee.fullname : "";
        this.form.customerResponseAt = data.customerResponseAt ? this.getDateFromMls(data.customerResponseAt) : ""
      } catch (e) {
        this.$notification.error({
          message: "Thất bại",
          description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
        })
      }
    }
  }

}
